import { isAxiosError } from 'axios';

import { hasAuthSession } from './authTokenStorage';

export const isUnauthorizedWithoutSession = (error: unknown) => {
  return (
    !hasAuthSession() && isAxiosError(error) && error.response?.status === 401
  );
};
